import { type IShallowRentalDispense } from "@/interfaces/api/shallow-rental-dispense.interface"
import { ShallowRentalMutation } from "@/models/shallow-rental-mutation"

export class ShallowRentalDispense extends ShallowRentalMutation implements IShallowRentalDispense {
  public static className = "ShallowRentalDispense"
  public static verboseName = "Verhuur (ondiep)"

  rentalDispenseItem: number

  constructor(rentalDispense: IShallowRentalDispense) {
    super(rentalDispense)

    this.rentalDispenseItem = rentalDispense.rentalDispenseItem
  }
}
